import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  bidListScrollArea: {
    flexGrow: 1
  },
  bidList: {
    width: '100%'
  },
  scroll: {
    height: '100%',
    overflow: 'scroll'
  },
  bidsLoading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2)
  },
  loadingTypography: {
    marginBottom: theme.spacing(2)
  },
  noBidsTypography: {
    fontWeight: 'bold',
    opacity: 0.6,
    textAlign: 'center',
    padding: theme.spacing(2)
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/BidList/styles.js